export enum TabId {
    Common = 'COMMON',
    Limits = 'LIMITS',
    Formula = 'FORMULA',
}

export type TabType = { label: string; id: TabId };
